import { useEffect, useState } from "react";

import instance from "@store/middleware/api";

export interface SubscriptionConfig {
  basePriceMonthly: number;
  basePriceAnnual: number;
  includedChannels: number;
  includedClaims: number;
  additionalChannelPrice: number;
  additionalClaimsPrice: number;
  claimIncrement: number;
  annualDiscountPercent: number;
  singleLicensePrice: number; // Standard tier
  plusLicensePrice: number; // Plus tier
  wavLicensePrice: number;
  upgradeExtensionWindow: number;
}

const DEFAULT_CONFIG: SubscriptionConfig = {
  basePriceMonthly: 19,
  basePriceAnnual: 411,
  includedChannels: 1,
  includedClaims: 5,
  additionalChannelPrice: 19,
  additionalClaimsPrice: 10,
  claimIncrement: 5,
  annualDiscountPercent: 10,
  singleLicensePrice: 29,
  plusLicensePrice: 59,
  wavLicensePrice: 3,
  upgradeExtensionWindow: 7,
};

let cached: SubscriptionConfig | null = null;

export function useSubscriptionConfig(): SubscriptionConfig {
  const [config, setConfig] = useState<SubscriptionConfig>(cached || DEFAULT_CONFIG);

  useEffect(() => {
    if (cached) return;
    instance.get("/subscription-config").then((res) => {
      const d = res.data;
      const c: SubscriptionConfig = {
        basePriceMonthly: Number(d.basePriceMonthly),
        basePriceAnnual: Number(d.basePriceAnnual),
        includedChannels: Number(d.includedChannels),
        includedClaims: Number(d.includedClaims),
        additionalChannelPrice: Number(d.additionalChannelPrice),
        additionalClaimsPrice: Number(d.additionalClaimsPrice),
        claimIncrement: Number(d.claimIncrement),
        annualDiscountPercent: Number(d.annualDiscountPercent),
        singleLicensePrice: Number(d.singleLicensePrice),
        plusLicensePrice: Number(d.plusLicensePrice),
        wavLicensePrice: Number(d.wavLicensePrice),
        upgradeExtensionWindow: Number(d.upgradeExtensionWindow) || 7,
      };
      cached = c;
      setConfig(c);
    }).catch(() => {});
  }, []);

  return config;
}
